import { create } from "zustand";

const defaultPagination = {
    page: 1,
    type: "" as string,
};

interface PaginationState {
    pagination: typeof defaultPagination;
    setPagination: (pagination: any) => void;
    resetPagination: () => void;
}

export const usePaginationStore = create<PaginationState>(set => ({
    pagination: defaultPagination,
    setPagination: pagination => set({ pagination }),
    resetPagination: () => set({ pagination: defaultPagination }),
}));
